import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import API from "../../api/axios"
import AdminLayout from "./AdminLayout"
import "./admin.css"

const AdminDashboard = () => {
  const [stats, setStats]     = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    API.get("/admin/stats")
      .then(res => setStats(res.data.data))
      .catch(err => console.error(err))
      .finally(() => setLoading(false))
  }, [])

  const fmtKES = (n) => `KES ${Number(n || 0).toLocaleString("en-KE")}`
  const fmtDate = (d) => d ? new Date(d).toLocaleDateString("en-KE", { day: "numeric", month: "short", year: "numeric" }) : "-"

  const statCards = stats ? [
    { label: "Total Students",  value: stats.totalStudents,  icon: "fa-users",       color: "blue" },
    { label: "Total Courses",   value: stats.totalCourses,   icon: "fa-book",        color: "green" },
    { label: "Total Revenue",   value: fmtKES(stats.totalRevenue), icon: "fa-coins", color: "gold" },
    { label: "Pending Payments",value: stats.pendingPayments,icon: "fa-clock",       color: "orange" },
    { label: "New Contacts",    value: stats.newContacts,    icon: "fa-envelope",    color: "purple" },
  ] : []

  const colorMap = {
    blue:   { bg: "rgba(13,110,253,0.1)",  color: "#0d6efd" },
    green:  { bg: "rgba(46,125,82,0.12)",  color: "#2e7d52" },
    gold:   { bg: "rgba(201,162,39,0.12)", color: "#a07c10" },
    orange: { bg: "rgba(255,152,0,0.12)",  color: "#e65100" },
    purple: { bg: "rgba(111,66,193,0.12)", color: "#6f42c1" },
  }

  return (
    <AdminLayout title="Dashboard">
      {loading ? (
        <div className="admin-empty"><i className="fa fa-spinner fa-spin"></i> Loading stats…</div>
      ) : (
        <>
          {/* Stats */}
          <div className="admin-stats">
            {statCards.map(c => (
              <div key={c.label} className="admin-stat-card">
                <div className="stat-icon" style={{ background: colorMap[c.color]?.bg, color: colorMap[c.color]?.color }}>
                  <i className={`fa ${c.icon}`}></i>
                </div>
                <div className="stat-label">{c.label}</div>
                <div className="stat-value">{c.value}</div>
              </div>
            ))}
          </div>

          {/* Recent Payments */}
          <div className="admin-section">
            <div className="admin-section-header">
              <h3>Recent Payments</h3>
              <Link to="/admin/payments" style={{ fontSize: 13, color: "#c9a227", textDecoration: "none" }}>View all →</Link>
            </div>
            <div className="admin-table-wrap">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>Student</th>
                    <th>Course</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {stats?.recentPayments?.length === 0 && (
                    <tr><td colSpan="6" style={{ textAlign: "center", color: "#aaa", padding: 24 }}>No payments yet</td></tr>
                  )}
                  {stats?.recentPayments?.map(p => (
                    <tr key={p.id}>
                      <td>{p.user?.name}<br /><small style={{ color: "#999" }}>{p.user?.email}</small></td>
                      <td>{p.course?.title}</td>
                      <td style={{ fontWeight: 600 }}>KES {Number(p.amount).toLocaleString()}</td>
                      <td><span className={`badge badge-${p.status}`}>{p.status}</span></td>
                      <td>{fmtDate(p.createdAt)}</td>
                      <td>
                        {p.status === "pending" && (
                          <ApproveBtn paymentId={p.id} onApproved={() =>
                            setStats(prev => ({
                              ...prev,
                              pendingPayments: prev.pendingPayments - 1,
                              recentPayments: prev.recentPayments.map(x =>
                                x.id === p.id ? { ...x, status: "completed" } : x
                              ),
                            }))
                          } />
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Recent Contacts */}
          <div className="admin-section">
            <div className="admin-section-header">
              <h3>Recent Contact Submissions</h3>
              <Link to="/admin/contacts" style={{ fontSize: 13, color: "#c9a227", textDecoration: "none" }}>View all →</Link>
            </div>
            <div className="admin-table-wrap">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Subject</th>
                    <th>Status</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {stats?.recentContacts?.length === 0 && (
                    <tr><td colSpan="5" style={{ textAlign: "center", color: "#aaa", padding: 24 }}>No contacts yet</td></tr>
                  )}
                  {stats?.recentContacts?.map(c => (
                    <tr key={c.id}>
                      <td>{c.name}</td>
                      <td>{c.email}</td>
                      <td>{c.subject}</td>
                      <td><span className={`badge badge-${c.status}`}>{c.status}</span></td>
                      <td>{fmtDate(c.createdAt)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </AdminLayout>
  )
}

const ApproveBtn = ({ paymentId, onApproved }) => {
  const [loading, setLoading] = useState(false)
  const approve = async () => {
    setLoading(true)
    try {
      await API.patch(`/payments/${paymentId}/approve`)
      onApproved()
    } catch (err) {
      alert(err.response?.data?.message || "Approval failed.")
    } finally {
      setLoading(false)
    }
  }
  return (
    <button className="btn-sm btn-approve" onClick={approve} disabled={loading}>
      {loading ? <i className="fa fa-spinner fa-spin"></i> : "Approve"}
    </button>
  )
}

export default AdminDashboard
